import { useMemo } from 'react';

import { Categories } from 'restful/tickets';
import { viewItemList } from 'services/avo';
import { useTrackEventOnce } from 'services/datalayer/hooks';

import { useTicketInfoLookup } from 'components/@tickets/hooks';

import { useEventBundle } from './useEventBundle';
import { mapTicketToDataLayer } from './utils';

export const useTrackViewItemList = (categories: Categories) => {
  const lookup = useTicketInfoLookup();
  const eventBundle = useEventBundle();

  const flatTicketList = useMemo(
    () =>
      categories
        .flatMap((category) =>
          category.tickets.flatMap((item) => {
            const { discountedPrice, originalPrice } = lookup(item.id);
            return {
              ...mapTicketToDataLayer(item, eventBundle, {
                discountedPrice,
                originalPrice,
              }),
            };
          }),
        )
        .map((item, index) => ({ ...item, index })),
    [categories, eventBundle, lookup],
  );

  useTrackEventOnce({
    trackFn: viewItemList,
    variables: {
      ...eventBundle,
      // Items contains the items we are viewing on the page
      items: flatTicketList,
      currency: 'SAR',
      value: 0,
    },
  });
};
